import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import handleError from "@lib/helpers/handleError";
import { RECRUITER_KEYS } from "./keys";

export default function useRecruiterDetails() {
  const api = useAxios();
  const { data, error, isLoading } = useQuery({
    queryKey: RECRUITER_KEYS.details(),
    queryFn: () => api.get("/me"),
    refetchOnWindowFocus: false,
    retry: false,
    // Recruiter details rarely change within a session; cache to avoid refetching
    // /me on every page navigation.
    staleTime: 5 * 60_000,
  });

  handleError(error);
  const { recruiter, plan, account_status } = data?.data ?? {};

  return { recruiter, plan, accountStatus: account_status, isLoading };
}
